import React from 'react';
import { GiftIcon } from 'lucide-react';
export function ExtraBonus() {
  return <div className="mt-6 rounded-2xl border-2 border-yellow-300 bg-yellow-50/70 overflow-hidden shadow-md shadow-yellow-100" data-id="element-70">
      <div className="px-4 py-2.5 bg-yellow-100 border-b border-yellow-200 flex items-center gap-2 justify-center text-center" data-id="element-71">
        <GiftIcon className="w-4 h-4 text-yellow-700 flex-shrink-0" data-id="element-72" />
        <p className="font-extrabold text-xs sm:text-sm text-yellow-800 uppercase tracking-wide" data-id="element-73">
          Comprando hoy llevate este bono extra{' '}
          <span className="text-green-700" data-id="element-74">GRATIS</span>
        </p>
      </div>

      <div className="flex items-center gap-3 px-4 py-3" data-id="element-75">
        <span className="text-2xl flex-shrink-0" data-id="element-76">🧮</span>
        <h3 className="font-extrabold text-sm sm:text-base text-slate-900 leading-tight" data-id="element-77">
          BONO EXTRA — Calculadora de Fluidoterapia Veterinaria + Dosis de
          Emergencia
        </h3>
      </div>
    </div>;
}